import { faqWidgetStyles } from "@bevco/Widgets/VerndaleBox/FaqWidget";

faqWidgetStyles.title = {
    variant: "h2",
};
